import { makeStyles } from '@material-ui/core';
import { em, vh } from '../common/helpers/dimension-helper';
import { themeColor } from '../mui-theme';

export const styles = makeStyles(theme => ({
  main: {
    fontSize: vh(2.083),
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '15vh',
    width: '55vw',
    backgroundColor: themeColor.lightBackground,
    outline: 0,
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontStretch: 'normal',
    fontStyle: 'normal',
    letterSpacing: '1.2px',
    position: 'relative',
  },
  innerTitle: {
    backgroundColor: 'white',
    width: '100%',
  },
  contentTitle: {
    fontSize: vh(3.125),
    fontWeight: 500,
    lineHeight: 'normal',
    color: themeColor.defaultTextColor,
    padding: '30px',
  },
  inner: {
    marginTop: '5vh',
    marginBottom: '20px',
  },
  innerKeypad: {
    marginTop: '5vh',
    marginBottom: '2.6vh',
    paddingLeft: '5vw !important',
  },
  iconLabelContainer: {
    alignItems: 'center',
    padding: '0 2vw',
  },
  iconLabel: {
    height: '2.34vh',
    width: '1.97vw',
    marginTop: '0.65vh',
  },
  scanBarcodeText: {
    fontSize: vh(2.604),
    fontWeight: 'normal',
    lineHeight: '3.65vh',
    letterSpacing: '0.05vw',
    marginLeft: '0.44vw',
    display: 'flex',
    alignItems: 'center',
  },
  checkIdInstruction: {
    padding: '0 30px',
    marginTop: '2vh',
  },
  checkIdInstructionText: {
    fontSize: em(18),
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.56,
    letterSpacing: '0.56px',
    color: themeColor.blackish,
  },
  cancelButtonContainer: {
    alignSelf: 'flex-start',
    display: 'flex',
    position: 'absolute',
    bottom: '0',
    marginBottom: '2.6vh',
  },
  cancelButton: {
    fontSize: vh(2.08),
    color: themeColor.defaultTextColor,
  },
  listButton: {
    maxWidth: '16vw',
    marginLeft: '0.5vw',
    fontSize: vh(2.08),
    lineHeight: 1.1,
    textTransform: 'uppercase',
  },
  leftHandButton: {
    marginRight: '1vw',
  },
  component: {
    height: '100%',
  },
  sortFilters: {
    padding: '0 1.5vw',
  },
  categoryLabel: {
    width: '14.27vw',
    height: '2.08vh',
    fontSize: vh(2.08),
    color: theme.palette.info.dark,
    fontWeight: 500,
    marginRight: '81.77vw',
    marginTop: '1.04vh',
    marginBottom: '1.04vh',
    paddingRight: 0,
    justifyContent: 'start',
  },
  transactions: {
    margin: '1.5vh 0',
    height: '50%',
    overflowY: 'auto',
    padding: '1.25vh 1.5vw',
  },
  controls: {
    padding: '1.5vw',
    width: '100%',
  },
  transactionItemContainer: {
    position: 'relative',
    height: '7.29vh',
    backgroundColor: themeColor.white,
    boxShadow: `0 1px 4px 0 ${themeColor.almosttransparentblack}`,
    border: '2px solid',
    cursor: 'pointer',
    marginBottom: 12,
  },
  transactionItemCheck: {
    position: 'absolute',
    color: theme.palette.primary.main,
    width: 24,
    height: 24,
    top: -14,
    left: -17,
  },
  transactionImage: {
    width: '2.19vw',
    height: '4.68vh',
    paddingLeft: '0 1.17vw',
    backgroundColor: themeColor.defaultTextColor,
    color: themeColor.defaultTextColor,
    fill: themeColor.defaultTextColor,
  },
  transactionSequenceNumber: {
    width: '18.59vw',
    height: '3.12vh',
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontSize: vh(2.34),
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.33,
    letterSpacing: 0.15,
    color: themeColor.almostblack,
    overflow: 'hidden',
  },
  transactionItemName: {
    width: '18.59vw',
    height: '2.6vh',
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontSize: vh(1.82),
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.43,
    letterSpacing: 0.25,
    color: themeColor.blackish,
  },
  transactionDate: {
    width: '14.27vw',
    height: '3.12vh',
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontSize: vh(2.34),
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.33,
    letterSpacing: 0.17,
    color: themeColor.almostblack,
  },
  transactionTotal: {
    width: '30.31vw',
    height: '3.12vh',
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontSize: vh(2.34),
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.33,
    letterSpacing: 0.17,
    textAlign: 'right',
    paddingRight: '0 1.61vw',
    color: themeColor.almostblack,
  },
}));
